import React, { useEffect, useRef, useState } from "react";
import { FaGithubSquare, FaLinkedin } from "react-icons/fa";
import { FiMail } from "react-icons/fi";
import { Link } from "react-router-dom";

export default function Header({ toggleDarkMode }) {
  const [extend, setExtend] = useState(false);

  const mobileNavRef = useRef(null);
  const headerRef = useRef(null);

  // Click Outside Event Handler
  const handleOutsideClick = (e) => {
    if (
      mobileNavRef.current.contains(e.target) ||
      headerRef.current.contains(e.target)
    ) {
      return;
    }
    setExtend(false);
  };
  // Mobile Nav Toggle
  const handleNavToggle = () => {
    setExtend(!extend);
  };

  // Click Outside Event Listener
  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <>
      {extend && (
        <div className="absolute w-full h-full inset-0 bg-white bg-opacity-40 dark:bg-black dark:bg-opacity-40 z-10"></div>
      )}
      <nav
        ref={headerRef}
        className="bg-opacity-70 dark:bg-opacity-70 backdrop-blur-lg border-gray-200 px-4 lg:px-6 py-4 dark:bg-neutral-800 fixed top-0 inset-x-0 z-20"
      >
        <div className="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl relative">
          <h4 className="flex items-center">
            <Link
              to="/"
              className="self-center text-2xl uppercase font-semibold whitespace-nowrap text-neutral-900 dark:text-neutral-100"
            >
              Salman Ahmed
            </Link>
          </h4>

          <div className="justify-between items-center flex w-auto md:order-1">
            <ul
              ref={mobileNavRef}
              className={`absolute top-12 right-0 bg-neutral-100 dark:bg-neutral-800 p-8 md:p-0 rounded md:bg-transparent md:dark:bg-transparent md:static flex flex-col  mt-4 font-medium lg:gap-6 gap-4 md:flex-row md:mt-0 items-start md:items-center transition-all origin-top-right md:scale-100 ${
                extend ? "scale-1" : "scale-0"
              }`}
            >
              <li>
                <a
                  href="https://github.com/shSalman009"
                  target="_blank"
                  rel="noreferrer"
                  className="flex gap-4 bg-transparent transition duration-300 text-3xl text-neutral-700 hover:text-neutral-800  dark:text-neutral-300 dark:hover:text-neutral-100"
                >
                  <FaGithubSquare />
                  <p className="md:hidden text-lg font-semibold">Github</p>
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/in/salman-ahmed-77682823b/"
                  target="_blank"
                  rel="noreferrer"
                  className="flex gap-4 bg-transparent transition duration-300 text-3xl text-neutral-700 hover:text-neutral-800  dark:text-neutral-300 dark:hover:text-neutral-100"
                >
                  <FaLinkedin />
                  <p className="md:hidden text-lg font-semibold">LinkedIn</p>
                </a>
              </li>
              <li className="lg:hidden">
                <a
                  href="mailto:shahsalmanahmed009@gmail.com"
                  className="flex gap-4 bg-transparent transition duration-300 text-3xl text-neutral-700 hover:text-neutral-800  dark:text-neutral-300 dark:hover:text-neutral-100"
                >
                  <FiMail />
                  <p className="md:hidden text-lg font-semibold">E-Mail</p>
                </a>
              </li>
              <li className="hidden lg:block">
                <a
                  href="mailto:shahsalmanahmed009@gmail.com"
                  className="flex gap-2 transition duration-300 py-2 pr-4 pl-3 text-xl text-neutral-700 hover:text-neutral-800 dark:text-neutral-300 dark:hover:text-neutral-100"
                >
                  shahsalmanahmed009@gmail.com
                </a>
              </li>
            </ul>
            <button
              onClick={toggleDarkMode}
              type="button"
              className="flex transition ml-8 items-center p-2 mr-2 text-xs font-medium text-gray-700 bg-white border border-gray-200 rounded-lg toggle-dark-state-example hover:bg-gray-100 hover:text-blue-700 focus:z-10 dark:bg-neutral-900 focus:outline-none dark:text-gray-400 dark:border-neutral-900 dark:hover:text-white dark:hover:bg-neutral-700"
            >
              <svg
                aria-hidden="true"
                data-toggle-icon="moon"
                className="w-4 h-4 dark:hidden"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"></path>
              </svg>
              <svg
                className="w-4 h-4 hidden dark:block"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                  fillRule="evenodd"
                  clipRule="evenodd"
                ></path>
              </svg>
              <span className="sr-only">Toggle dark/light mode</span>
            </button>
            <div className="md:hidden flex items-center md:order-2">
              <button
                onClick={handleNavToggle}
                type="button"
                className="inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                aria-controls="mobile-menu-2"
                aria-expanded="false"
              >
                <span className="sr-only">Open main menu</span>
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <svg
                  className="hidden w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
